// import { Helmet } from 'react-helmet-async';

// const SEO = ({ title, description, canonical, schema }) => (
//     <Helmet>
//         <title>{title}</title>
//         <meta name="description" content={description} />
//         {canonical && <link rel="canonical" href={canonical} />}
//         <meta property="og:title" content={title} />
//         <meta property="og:description" content={description} />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content={canonical} />
//         {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
//     </Helmet>
// );

// export default SEO;


import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, keywords, schema }) => (
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {keywords && <meta name="keywords" content={keywords} />}
        <meta name="robots" content="index, follow" />
        {canonical && <link rel="canonical" href={canonical} />}

        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        {canonical && <meta property="og:url" content={canonical} />}
        {/* Schema (optional — page-wise schema ho to) */}
        {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
);

export default SEO;